// extracted by mini-css-extract-plugin
module.exports = {"root":"c6674c78","slides":"c9e09671","menu":"cfd90c90","tab":"_6ccbf1f6","tabActive":"_4b41171e","radio":"_25d5d365","fullscreen":"b64c897f"};